<template>
  <div class="conter">
    <div class="currency_suggest">
      <div class="titel">
        <span>同城经典案例</span>
      </div>
      <div>
        <div class="case_li" v-for="(item, index) in arrRanks" :key="index" @click="getDetail(item.id)">
          <p>
            {{ item.type }}<span>|</span
            >{{ item.city + item.community_name + "项目案例" }}
          </p>
          <div class="attr">
            <div class="attr-left">
              <p>{{ item.house_area }}</p>
              <p>{{ item.house_cate || "暂无" }}</p>
            </div>
            <div class="attr-right">
              <img src="@/assets/images/ant/map/watch.png" alt="" />
              <span>{{ item.views || item.real_views }}</span>
            </div>
          </div>
          <div class="pic-list">
            <div
              class="pic-item"
              v-for="(imgItem, imgIndex) in item.images"
              :key="imgIndex"
            >
              <img v-lazy="imgItem.img_url" alt="" v-if="imgIndex <= 2" />
            </div>
          </div>

          <div :class="['state-icon', stateStyle(item.state)]"></div>
        </div>
        <!-- <div class="case_list" v-for="(item, index) in arrRanks" :key="index" @click="getDetail(item.id)">
          <div class="case_img">
            <div class="case_img_list" v-for="(imgitem,imgindex) in item.images" :key="imgindex">
              <img v-lazy="imgitem.img_url" alt="">
            </div>
          </div>
          <div class="title_xiao">
            <span class="xiao_t"
              >{{ item.type ? item.type + " | " : ""
              }}{{ item.city ? item.city : ""
              }}{{
                item.community_name ? item.community_name : ""
              }}项目案例</span
            >
            <span class="lookNum">{{
              item.views == 0 ? item.real_views : item.views
            }}</span>
          </div>
          <div class="case_tips">
            <div class="case_type">
              <div class="label_type">
                <span v-if="item.house_cate">{{ item.house_cate }}</span>
                <span v-if="item.house_area">{{ item.house_area + "㎡" }}</span>
              </div>
              <div>
                进度：{{
                  item.state == 1
                    ? "已签约"
                    : item.state == 2
                    ? "施工中"
                    : item.state == 3
                    ? "已完工"
                    : ""
                }}
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="map_img">
        <img src="@/assets/images/antV2/scheme/map_icon.png" alt="" />
        <div class="btn" @click="goMap">查看更多</div>
      </div>
    </div>
    <div class="currency_suggest" v-if="arrPos.length">
      <div class="titel_tips">
        <span>品牌实力</span>
      </div>
      <div class="deploy-banner">
        <swiper class="slide" :options="swiperOption" ref="mySwiper">
          <swiper-slide
            v-for="(switem, swindex) in arrPos"
            :key="swindex"
            class="slide-list"
          >
            <!-- <div class="drang-lab" v-if="switem.imgname != ''">
              {{ switem.imgname }}
            </div> -->
            <!-- @click="lookImg(swindex)" -->
            <img :src="switem.picurl" alt="" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    arrPos: {
      type: Array,
      default: false,
    },
    arrRanks: {
      type: Array,
      default: false,
    },
  },
  data() {
    const vm = this;
    return {
      //上传的图片
      arrSwiperImg: [
        {
          imgSrc: require("@/assets/images/ant/diagram/0001.png"),
          imgname: "",
        },
        {
          imgSrc: require("@/assets/images/ant/diagram/0002.png"),
          imgname: "",
        },
        {
          imgSrc: require("@/assets/images/ant/diagram/0003.png"),
          imgname: "",
        },
        {
          imgSrc: require("@/assets/images/ant/diagram/0004.png"),
          imgname: "",
        },
        {
          imgSrc: require("@/assets/images/ant/diagram/0005.png"),
          imgname: "",
        },
      ],
      //轮播图配置
      swiperOption: {
        speed: 200,
        spaceBetween: 0,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
        on: {
          slideChangeTransitionEnd() {
            vm.headIndex = this.activeIndex;
          },
        },
      },
    };
  },
  computed: {
    // 轮播实例对象
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    stateStyle(state) {
      let className = "";
      switch (Number(state)) {
        case 1:
          className = "yqy";
          break;
        case 2:
          className = "sgz";
          break;
        case 3:
          className = "ywg";
          break;
      }
      return className;
    },
    //点击跳转案例地图
    goMap() {
      this.$router.push({ path: `/antMap/index?antform=${1}` });
    },
    //跳转项目案例详情
    getDetail(id) {
      this.$router.push({ path: `/antdetails/index?id=${id}` });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>